import type { Complex } from "./complex";

export type Preset = {
  id: string;
  name: string;
  c: Complex;
  hint: string;
};

export const PRESETS: readonly Preset[] = [
  {
    id: "inside",
    name: "Main cardioid",
    c: { re: -0.12, im: 0.16 },
    hint: "Deep inside. The Julia set is a simple closed curve.",
  },
  {
    id: "rabbit",
    name: "Douady rabbit",
    c: { re: -0.123, im: 0.745 },
    hint: "Period-3 bulb. Three ears of connected lace.",
  },
  {
    id: "seahorse",
    name: "Seahorse valley",
    c: { re: -0.75, im: 0.1 },
    hint: "Just above the cusp. Spirals on both sides of the boundary.",
  },
  {
    id: "sanmarco",
    name: "San Marco",
    c: { re: -0.75, im: 0 },
    hint: "The cusp itself. A dragon, almost a dendrite.",
  },
  {
    id: "airplane",
    name: "Airplane",
    c: { re: -1.75488, im: 0 },
    hint: "Tip of the period-2 antenna.",
  },
  {
    id: "dendrite",
    name: "Dendrite",
    c: { re: 0, im: 1 },
    hint: "On the imaginary axis. A tree of filaments.",
  },
  {
    id: "siegel",
    name: "Siegel disk",
    c: { re: -0.39054, im: -0.58679 },
    hint: "An interior rotation. A smooth lake of lace.",
  },
  {
    id: "spiral",
    name: "Spiral",
    c: { re: -0.745, im: 0.113 },
    hint: "Near the seahorse. Dust tightens into coils.",
  },
];

export function presetById(id: string): Preset | undefined {
  return PRESETS.find((p) => p.id === id);
}
